import { toast } from "react-toastify";

export function handleApiError(
  err: any,
  fallbackMessage: string = "En uventet feil oppstod.",
) {
  if (!err.response?.data && err.status === 403) {
    toast.error("Du har ikke tilgang til denne funksjonen.");
    console.error("API error:", err);
  } else {
    const message =
      err?.response?.data?.message ||
      `${fallbackMessage} ${err?.message || ""}`;
    toast.error(message);
    console.error("API error:", err);
  }
}
